class Header {
  constructor() {
    this.$el = $('.header');

    this.ui = {
      $toggle: $('.navbar__toggle', this.$el),
      $body: document.querySelector('body'),
      $navbarCollapse: $('.navbar-mobile', this.$el),
      $navRightSide: $('.header__right-side', this.$el),
      $navBarContainer: $('.header__container', this.$el),
      $flag: $('.header-submenu__flag-button', this.$el),
      $dropMenu: $('.header-submenu__drop-down-menu', this.$el),
      $icon_1: $('.navbar__toggle__large-line', this.$el),
      $icon_2: $('.navbar__toggle__small-line', this.$el),
      $subMenuBlog: $('.navbar__sub-menu__hidden'),
      $subMenuBlogButton: $('.navbar__item__link--drop-down'),
    };

    this.state = {
      navbarDisplay: false,
      langDisplay: false,
      openClassSubMenuBlog: 'navbar__sub-menu'
    };

    this.ui.$toggle.on('click', this.toggleNavbar.bind(this));
    this.ui.$subMenuBlogButton.on('click', this.toggleSubMenuBlog.bind(this));
    this.ui.$flag.on('click', this.toggleLang.bind(this));
    $(document).on('click', this.clickOutside.bind(this));
  }

  toggleSubMenuBlog(){
    this.ui.$subMenuBlog[0].classList.toggle('navbar__sub-menu')
    this.ui.$subMenuBlogButton[0].classList.toggle('navbar__item__link--drop-down__open')
  }

  toggleLang(){
    const ddMenu = document.querySelectorAll('.header-submenu__drop-down-menu')

    if(ddMenu.length > 0){
      let i;
      for (i = 0; i < ddMenu.length; i++) {
        ddMenu[i].classList.toggle('header-submenu__drop-down-menu__show')
      }
    }
  }

  clickOutside(e){
    if(!e.target.classList.contains('navbar__sub-menu__hidden') && !e.target.classList.contains('navbar__item__link--drop-down')){
      this.ui.$subMenuBlog.length && this.ui.$subMenuBlog[0].classList.remove('navbar__sub-menu')
      this.ui.$subMenuBlogButton.length && this.ui.$subMenuBlogButton[0].classList.remove('navbar__item__link--drop-down__open')
    }
    $(document).click(function(event) {
      let $target = $(event.target);

      if(!$target.closest('.header-submenu__drop-down-menu').length &&
          $('.header-submenu__drop-down-menu').is(":visible")) {

        const ddMenu = document.querySelectorAll('.header-submenu__drop-down-menu')

        if(ddMenu.length > 0){
          var i;
          for (i = 0; i < ddMenu.length; i++) {
            ddMenu[i].classList.toggle('header-submenu__drop-down-menu__show')
          }
        }
      }
    });
  }

  toggleNavbar() {
    this.state.navbarDisplay = !this.state.navbarDisplay;
    this.ui.$toggle.toggleClass('collapsed', !this.state.navbarDisplay);

    // for iPhone
    document.documentElement.classList.toggle('prevent-scroll-header-menu');
    document.body.classList.toggle('prevent-scroll-header-menu');

    this.ui.$navbarCollapse.toggleClass('navbar-mobile__show', this.state.navbarDisplay);
    this.ui.$navRightSide.toggleClass('header__right-side__show', this.state.navbarDisplay);
    this.$el.toggleClass('header__show', this.$el);
    this.ui.$navBarContainer.toggleClass('header__container__show', this.state.navbarDisplay);
    this.ui.$icon_1.toggleClass('navbar__toggle__large-line__close', this.state.navbarDisplay);
    this.ui.$icon_2.toggleClass('navbar__toggle__small-line__close', this.state.navbarDisplay);
  }
}

export default new Header();
